var r=-1;export{r as DEV_CENTER_CLI_APP_ID};
